import { matchPath } from 'react-router-dom';
import _ from 'lodash';

import { tldRegex } from 'utils/regex';

// Used to join a base that may or may not have
// a trailing '/' with a relative path that begins
// with a leading '/'. This will prevent paths
// with double slashes ('//').
export function joinPath(base: string, path: string): string {
  return base.charAt(base.length - 1) === '/' ? base.slice(0, -1) + path : base + path;
}

export function shortenUrlToHost(fullUrl: string) {
  const re = new RegExp('.' + tldRegex + '/.+');
  return fullUrl.replace(re, (matchingString: string) => {
    const innerRe = new RegExp('.' + tldRegex);
    return _.first(matchingString.match(innerRe)) || '';
  });
}

export function isWidgetPathname(pathname: string): boolean {
  return !_.isNil(
    matchPath(pathname, {
      path: '/:businessDomain/:widget(widget)',
      exact: false,
    })
  );
}
